import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckBox, FerramentasDaListagem, FerramentasDeDetalhe, RadioGroup, SelectComponent } from "../../shered/components";
import { VForm, VTextField, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { LigaService, IListagemLigas } from "../../shered/services/api/liga/LigaService";
import {
    Box, LinearProgress,
    Paper, Tab,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow, Tabs, Typography, TextField,
    FormLabel, tableCellClasses, FormControl,
    Select, InputLabel,
    MenuItem,
    RadioGroup as MuiRadioGroup,
    FormControlLabel,
    Radio, Switch, tabsClasses, useTheme
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { styled } from '@mui/material/styles';
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { useDebounce } from "../../shered/hooks";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { Scope } from "@unform/core";
import { VInputNumber } from "../../shered/forms/VInputNumber";
import { DisputaService, IDadosConferencia, IDadosDivisao, IDadosEscolhas, IDadosEscolhasCalouro, IDadosFranquiaDisputa, IDadosFreeAgency, IDadosLeilao, IDetalheDisputaLiga, ILstDisputaDados, ILstDisputaTable, ILstDisputaTableAdd } from "../../shered/services/api/disputa/DisputaService";
import { FranquiaService, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { VTextFieldDatas } from "../../shered/forms/VTextFieldDatas";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { number } from "yup";
import { Loading } from "../../shered/components/loading/Loading";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService, IListagemTabelaHitoricoPicks, IListagemTabelaPicks } from "../../shered/services/api/draft/DraftService";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ? 
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {
               <Box sx={{ p: 1 }}>
                    <Grid>{children}</Grid>
                </Box>
            }
        </div>
         : ""}
        </>
    );
}
function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const columnsEscolhas: GridColDef[] = [
    {
        field: 'escolha',
        headerName: UtilidadeService.isMobile() ? 'ESC' : 'ESCOLHA',
        flex: 1,
        sortable: false,
        minWidth: UtilidadeService.isMobile() ? 50 : 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        headerClassName: 'super-app-theme--header',
    },
    {
        field: 'foto_Franquia_Origem',
        headerName: 'ORIGEM',
        flex: 1,
        sortable: false,
        minWidth: UtilidadeService.isMobile() ? 70 : 110,
        align: "center",
        headerAlign: "center",
        editable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
            <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 35 : 45} height={UtilidadeService.isMobile() ? 35 : 50} />
            : <img src="../../../semimagemescudo.png" alt={params.value} width={UtilidadeService.isMobile() ? 35 : 45} height={UtilidadeService.isMobile() ? 35 : 50} />
    },
    {
        field: 'nome_Franquia_Origem',
        headerName: 'FRANQUIA ORIGEM',
        flex: 1,
        editable: false,
        minWidth: UtilidadeService.isMobile() ? 110 : 190,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'left',
        align: 'left',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'foto_Franquia_Dono',
        headerName: 'DONO',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 70 : 190,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
            <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 35 : 45} height={UtilidadeService.isMobile() ? 35 : 50} /> :
            <img src="../../../semimagemescudo.png" alt={params.value} width={UtilidadeService.isMobile() ? 35 : 45} height={UtilidadeService.isMobile() ? 35 : 50} />
    },
    {
        field: 'nome_Franquia_Dono',
        headerName: 'FRANQUIA DONO',
        flex: 1,
        editable: false,
        minWidth: UtilidadeService.isMobile() ? 110 : 190,
        headerClassName: 'super-app-theme--header',
        headerAlign: 'left',
        align: 'left',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'foto_Jogador',
        headerName: 'FOTO',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 70 : 110,
        editable: false,
        align: "center",
        headerAlign: "center",
        sortable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => (params.value !== null && params.value !== "" && params.value !== undefined) ?
            <img src={params.value} alt={params.value} width={UtilidadeService.isMobile() ? 35 : 45} height={UtilidadeService.isMobile() ? 35 : 50}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = "../../../../semimagem.png";
                    currentTarget.style.borderRadius = "50%";
                    currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                    currentTarget.style.height = UtilidadeService.isMobile() ? "30px" :"40px";
                }}
            />
            : <img src={"../../../../semimagem.png"} width={UtilidadeService.isMobile() ? 30 : 40} height={UtilidadeService.isMobile() ? 30 : 40} style={{borderRadius:"50%"}}/>,
    },
    {
        field: 'nome_Jogador',
        headerName: 'JOGADOR',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 110 : 190,
        editable: false,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => {
            return (
                <Box
                    sx={{
                        whiteSpace: UtilidadeService.isMobile() ? 'pre-wrap' : "nowrap",
                    }}
                >
                    {params.value}
                </Box>
            );
        },
    },
    {
        field: 'escolha_Atual',
        headerName: 'STATUS',
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 530 : 190,
        editable: false,
        headerClassName: 'super-app-theme--header'

    }
];

export const ListagemDeHistorico: React.FC = () => {
    const theme = useTheme();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    //const classes = useStyles();
    const navigate = useNavigate();
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = useState(0);
    const [valueTabRodada, setValueTabRodada] = useState(0);
    const [codigoTemporadaFiltro, setCodigoTemporadaFiltro] = useState(0);
    const [codigoTemporadaFiltroInicial, setCodigoTemporadaFiltroInicial] = useState(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoImage, setLogoImage] = useState("");
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [escolhasCalourosRows, setEscolhasCalourosRows] = useState<IListagemTabelaHitoricoPicks[]>([]);
    const [escolhasInicialRows, setEscolhasInicialRows] = useState<IListagemTabelaHitoricoPicks[]>([]);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar.length >= 1) {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };


    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        }

        const fetchData = async () => {
            setRemoveLoading(false);
            await UtilidadeService.getTemporadas(true, Number(codigoLiga))
                .then((result) => {
                    setIsLoading(false);
                    const tmps = result.data.dado;
                    let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                    setLstTemporadas(lstTemporadasAux);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                });
            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;

                    setRemoveLoading(true);
                    setIsLoading(false);
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setLogoImage(liga.caminho_Logo);
                    setCodigoTemporadaFiltro(liga.codigo_Temporada);
                    setCodigoTemporadaFiltroInicial(liga.codigo_Temporada);
                    CarregarDadosHistoricoCalouro(Number(codigoLiga), liga.codigo_Temporada);
                    CarregarDadosHistoricoInicial(Number(codigoLiga), liga.codigo_Temporada);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

        }
        fetchData();
    }, [codigoLiga]);

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        CarregarDadosHistoricoCalouro(Number(codigoLiga), e.target.value);
    };

    const handleSelectedTemporadaInicial = async (e: { target: { name: string; value: any; }; }) => {
        CarregarDadosHistoricoInicial(Number(codigoLiga), e.target.value);
    };

    const CarregarDadosHistoricoCalouro = async (codigoLiga: number, codigoTemporada: number) => {
        await DraftService.getBuscarHitoricoLigaCalouros(codigoLiga, codigoTemporada)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.data.dado;
                setEscolhasCalourosRows(resultado);
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                //console.log(errors);
                if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Não foi possível carregar os dados do histórico! Favor entrar em contato com a TI ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
            });
    }

    const CarregarDadosHistoricoInicial = async (codigoLiga: number, codigoTemporada: number) => {
        await DraftService.getBuscarHitoricoLigaInicial(codigoLiga, codigoTemporada)
            .then((result) => {
                setShowModalMensagem(false);
                setIsLoading(false);
                let resultado = result.data.dado;
                //console.log(resultado);         
                setEscolhasInicialRows(resultado);
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                //console.log(errors);
                if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Não foi possível carregar os dados do histórico! Favor entrar em contato com a TI ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
            });
    }

    const paginaInicial = useMemo(() => {
        return Number(searchParams.get("paginaInicial") || "0");
    }, [searchParams]);

    const paginaCalouro = useMemo(() => {
        return Number(searchParams.get("paginaCalouro") || "0");
    }, [searchParams]);

    return (
        <LayoutBaseDePagina
            titulo={`Histórico - ${dadosLiga?.nome}`}
            showLogoImg={logoImage}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                //textoDaBusca={busca}
                aoClicarBotaoNovo={() => navigate('/usuario/liga')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}

            <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                <Grid container direction="column" padding={2} spacing={2}>
                    <Grid  alignItems="center" justifyContent="center" width="100%">
                        <Paper>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <Tabs value={value} onChange={handleChangeTabs}>
                                    <Tab label="Draft Calouro" {...a11yProps(0)} />
                                    <Tab label="Draft Inicial"{...a11yProps(1)} />
                                </Tabs>
                            </Box>
                            <TabPanel value={value} index={0}>
                                <Grid container spacing={2}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid  size={{xs:12, sm:12}} padding={1} >
                                        <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>HISTÓRICO POR TEMPORADA</Typography>
                                        <hr />
                                    </Grid>
                                    <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial">
                                        <Grid  size={{xs:12, sm:6, md:3}} >
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Temporadas"
                                                    value={codigoTemporadaFiltro}
                                                    onChange={(e) => { setCodigoTemporadaFiltro(Number(e.target.value)); handleSelectedTemporada(e) }}
                                                    style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                                >
                                                    <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                    {
                                                        lstTemporadas.map(qtd =>
                                                            <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                        )
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    {escolhasCalourosRows.length > 0 && (
                                        <Grid container size={{xs:12, sm:12}} padding={UtilidadeService.isMobile() ? 1 : 2} spacing={UtilidadeService.isMobile() ? 1 : 3} style={{ width: "100%" }}>
                                            <Grid  size={{xs:12, sm:12}} >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> PICKS CALOUROS</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}>
                                                <Grid  margin={UtilidadeService.isMobile() ? 0 : 1} paddingBottom={UtilidadeService.isMobile() ? 0 : 1}>
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Box sx={{
                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .MuiDataGrid-columnHeaderTitle': {
                                                        lineHeight: "20px",
                                                        whiteSpace: UtilidadeService.isMobile() ? 'break-spaces' : "nowrap",
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                       color: themeName === "light" ? "black" : "auto",
                                                    },
                                                    '& .rowEscolha': {
                                                        backgroundColor: '#fbc02d',
                                                        color: "black"
                                                    },
                                                    '& .rowEscolha:hover': {
                                                        backgroundColor: '#fbc02d',
                                                        color: "black"
                                                    },
                                                    '& .MuiDataGrid-cell:focus': {
                                                        outline: 'none',
                                                    },

                                                    '& .MuiDataGrid-cell:focus-within': {
                                                        outline: 'none',
                                                    }
                                                }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(rowsEscolhas) => rowsEscolhas.escolha}
                                                        rows={escolhasCalourosRows}
                                                        columns={columnsEscolhas}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 25,
                                                                    //page: paginaInicial,
                                                                },
                                                            },
                                                        }}
                                                        autoHeight
                                                        pageSizeOptions={[25, 50, 100]}
                                                        disableRowSelectionOnClick
                                                        getRowClassName={(params) => params.row.escolha_Atual === true ? `rowEscolha` : ''}
                                                        columnVisibilityModel={{
                                                            escolha_Atual: false
                                                        }}
                                                        disableDensitySelector
                                                        disableVirtualization
                                                        disableColumnFilter
                                                        disableColumnMenu
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 10 : "auto",
                                                        }}
                                                    //hideFooterPagination={true}
                                                    />
                                                </Box>
                                            </Grid>

                                        </Grid>
                                    )}
                                </Grid>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                {(!removeLoading || isLoading) && <Loading />}
                                <Grid  size={{xs:12, sm:12}} padding={1} >
                                    <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}>Histórico por Temporada</Typography>
                                    <hr />
                                </Grid>
                                <Grid container size={{xs:12, sm:12}} display="flex" justifyContent="initial">
                                    <Grid  size={{xs:12, sm:6, md:3}} >
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                label="Temporadas"
                                                value={codigoTemporadaFiltroInicial}
                                                onChange={(e) => { setCodigoTemporadaFiltroInicial(Number(e.target.value)); handleSelectedTemporadaInicial(e) }}
                                                style={{ fontSize: UtilidadeService.isMobile() ? 12 : 14, height: UtilidadeService.isMobile() ? 35 : "auto" }}
                                            >
                                                <MenuItem key="0" value={0}>Selecione...</MenuItem>
                                                {
                                                    lstTemporadas.map(qtd =>
                                                        <MenuItem key={qtd.codigo} value={qtd.codigo}>{qtd.label}</MenuItem>
                                                    )
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {escolhasInicialRows.length > 0 && (
                                    <Grid container direction="column" padding={2} spacing={3} style={{ width: "100%" }}>
                                        <Grid container spacing={2} style={{ width: "100%" }}>
                                            <Grid  size={{xs:12, sm:12}} >
                                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> PICKS </Typography>
                                                <hr />
                                            </Grid>
                                            <Grid  size={{xs:12, sm:12}} style={{ width: "100%" }}>
                                                <Grid  margin={1} paddingBottom={1}>
                                                    {!removeLoading && <Loading />}
                                                </Grid>
                                                <Box sx={{
                                                    height: 'auto', width: '100%', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto",
                                                    '& .super-app-theme--header': {
                                                        backgroundColor: theme.palette.common.black,
                                                        color: theme.palette.common.white,
                                                    },
                                                    '& .MuiDataGrid-columnHeaderTitle': {
                                                        lineHeight: "20px",
                                                        whiteSpace: UtilidadeService.isMobile() ? 'break-spaces' : "nowrap",
                                                    },
                                                    '& .super-app.negative': {
                                                        color: 'red',
                                                        fontWeight: 'bold'
                                                    },
                                                    '& .super-app.positive': {
                                                       color: themeName === "light" ? "black" : "auto",
                                                    },
                                                    '& .rowEscolha': {
                                                        backgroundColor: '#fbc02d',
                                                        color: "black"
                                                    },
                                                    '& .rowEscolha:hover': {
                                                        backgroundColor: '#fbc02d',
                                                        color: "black"
                                                    },
                                                    '& .MuiDataGrid-cell:focus': {
                                                        outline: 'none',
                                                    },
                                                    '& .MuiDataGrid-cell:focus-within': {
                                                        outline: 'none',
                                                    }
                                                }}>
                                                    <DataGrid
                                                        localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                                        getRowId={(rowsEscolhas) => rowsEscolhas.escolha}
                                                        rows={escolhasInicialRows}
                                                        columns={columnsEscolhas}
                                                        initialState={{
                                                            pagination: {
                                                                paginationModel: {
                                                                    pageSize: 25,
                                                                    //page: paginaInicial,
                                                                },
                                                            },
                                                        }}
                                                        autoHeight
                                                        pageSizeOptions={[25, 50, 100]}
                                                        disableRowSelectionOnClick
                                                        getRowClassName={(params) => params.row.escolha_Atual === true ? `rowEscolha` : ''}
                                                        columnVisibilityModel={{
                                                            escolha_Atual: false
                                                        }}
                                                        disableDensitySelector
                                                        disableVirtualization
                                                        disableColumnFilter
                                                        disableColumnMenu
                                                        sx={{
                                                            fontSize: UtilidadeService.isMobile() ? 10 : "auto",
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </TabPanel>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

        </LayoutBaseDePagina >
    );
}